import type { RpSectionOf } from '@mlm/shared';
import { cn } from '../../lib/cn';
import { RpLinkButton } from '../primitives';
import { rpJustify } from '../tokens';

/**
 * A focused conversion band. Distinct from `hero` in that it is deliberately
 * short and repeatable — the recommended shape is one near the bottom of every
 * page, plus one after any long persuasion run.
 */
export function RpCta({ section }: { section: RpSectionOf<'cta'> }) {
  const c = section.config;
  return (
    <div className="space-y-4">
      {c.eyebrow ? (
        <p className="text-xs font-semibold uppercase tracking-widest opacity-80">{c.eyebrow}</p>
      ) : null}
      <h2 className="font-heading text-2xl font-bold sm:text-3xl">{c.heading}</h2>
      {c.subheading ? <p className="text-base opacity-90">{c.subheading}</p> : null}
      <div
        className={cn('flex flex-wrap items-center gap-3 pt-1', rpJustify(section.style?.align))}
      >
        <RpLinkButton button={c.primaryCta} />
        {c.secondaryCta ? <RpLinkButton button={c.secondaryCta} /> : null}
      </div>
    </div>
  );
}
